import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useReadUserProfile } from '@/api/user-manager'
import { chipText, profileOf } from '../products/credit-profile'
import { CrmDialog } from './crm-dialog'
import { ProfileChip } from './profile-chip'
import { ProfileDialog } from './profile-dialog'

export function CreditIdentity() {
  const { data: user } = useReadUserProfile()
  const [profileOpen, setProfileOpen] = useState(false)
  const [crmOpen, setCrmOpen] = useState(false)

  const profile = profileOf(user?.profile?.occupation)
  const label = chipText({
    profile,
    currentSemester: user?.profile?.current_semester ?? null,
    crm: user?.profile?.crm ?? null,
    crmUf: user?.profile?.crm_uf ?? null,
  })

  return (
    <>
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
      >
        <Typography variant="body2" fontWeight={700}>
          Seu perfil:
        </Typography>
        <ProfileChip
          profile={profile}
          label={label}
          onClick={() => setProfileOpen(true)}
        />
      </Box>

      <ProfileDialog
        key={user?.profile?.graduation_date ?? 'empty'}
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
        user={user}
        profile={profile}
        onUpdateToDoctor={() => {
          setProfileOpen(false)
          setCrmOpen(true)
        }}
      />
      {profile === 'student' && (
        <CrmDialog
          open={crmOpen}
          mode="switch"
          onClose={() => setCrmOpen(false)}
          onBack={() => {
            setCrmOpen(false)
            setProfileOpen(true)
          }}
        />
      )}
    </>
  )
}
